import React from 'react';
import CommentInfo from './comment';
import Certification from './certification';
import './index.less';

// TODO: 改comment参数配置，删除skuCertification相关内容
/**  "globalDataKeys": [
              "i18n",
              "review.productReview",
              "product.productId",
              "product.labels",
              "product.productIsMarketGoods",
              "extend.recommendBillboard",
              "trade.hasLogistics",
              "trade.leadTimeInfo"
              "buyer.coreCountry"
              "trade.salesVolume",
            ] */
export default function Comment(props: {
  productId: DetailTypes.Product['productId'];
  i18n: DetailTypes.i18n;
  productReview?: ReviewType.ProductReview;
  labels: DetailTypes.Product['labels'];
  productIsMarketGoods: DetailTypes.Product['productIsMarketGoods'];
  recommendBillboard: TitleType.RecommendBillboard;
  hasLogistics: boolean;
  leadTimeInfo: TradeTypes.LeadTimeInfo;
  coreCountry: boolean;
  salesVolume: string;
}) {
  return (
    <div className="detail-product-comment">
      <CommentInfo {...props} />
      <Certification {...props} />
    </div>
  );
}
